import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './hooks/useAuth';
import HumanCheckModal from './components/HumanCheckModal/HumanCheckModal';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import NewspaperLayout from './pages/NewspaperLayout';
import NewspaperPage from './pages/NewspaperPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import FaqPage from './pages/FaqPage';
import ImpressumPage from './pages/ImpressumPage';
import PrivacyPage from './pages/PrivacyPage';
import StartPage from './pages/StartPage';
import AccountSettingsPage from './pages/AccountSettingsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <StartPage />,
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <AccountSettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    // Legally required to be publicly accessible — no auth guard
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    // Publicly accessible — GDPR Art. 13/14 transparency requirement
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    // Publicly accessible — no auth guard; lang param is optional
    path: '/faq/:lang?',
    element: <FaqPage />,
  },
  {
    path: '/:lang/:city',
    element: (
      <ProtectedRoute>
        <NewspaperLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <NewspaperPage />,
      },
      {
        path: 'story/:clusterId',
        element: <ArticleDetailPage />,
      },
      {
        path: '*',
        element: <NewspaperPage />,
      },
    ],
  },
]);

function AppInner() {
  const { isHumanCheckOpen, closeHumanCheck, onHumanCheckSuccess } = useAuth();
  return (
    <>
      <RouterProvider router={router} />
      <HumanCheckModal
        isOpen={isHumanCheckOpen}
        onClose={closeHumanCheck}
        onSuccess={onHumanCheckSuccess}
      />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
